module.exports = __webpack_public_path__ + "media/icons/basket-97aefada.svg";